document.documentElement.classList.remove('no-js');

const menuButton = document.querySelector('[data-menu-toggle]');
const mobileNav = document.querySelector('[data-mobile-nav]');
if (menuButton && mobileNav) {
  menuButton.addEventListener('click', () => {
    const open = mobileNav.classList.toggle('open');
    menuButton.setAttribute('aria-expanded', String(open));
  });
}

document.querySelectorAll('[data-testimonials]').forEach((section) => {
  const slides = [...section.querySelectorAll('[data-slide]')];
  const counter = section.querySelector('[data-counter]');
  let index = 0;
  const show = (next) => {
    if (!slides.length) return;
    slides[index].classList.remove('active');
    index = (next + slides.length) % slides.length;
    slides[index].classList.add('active');
    if (counter) counter.textContent = `0${index + 1} / 0${slides.length}`;
  };
  section.querySelector('[data-prev]')?.addEventListener('click', () => show(index - 1));
  section.querySelector('[data-next]')?.addEventListener('click', () => show(index + 1));
});

document.querySelectorAll('[data-product-form]').forEach((form) => {
  const optionInputs = [...form.querySelectorAll('[data-option]')];
  const variantSelect = form.querySelector('[data-variant-select]');
  if (!variantSelect || !optionInputs.length) return;
  const updateVariant = () => {
    const selectedOptions = optionInputs.map((input) => input.value);
    const variant = [...variantSelect.options].find((option) => {
      try { return JSON.stringify(JSON.parse(option.dataset.options)) === JSON.stringify(selectedOptions); }
      catch { return false; }
    });
    if (variant) {
      variantSelect.value = variant.value;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.value);
      window.history.replaceState({}, '', url);
    }
  };
  optionInputs.forEach((input) => input.addEventListener('change', updateVariant));
});
